import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback } from "react";
import cancelCustomerBooking from "../cancelCustomerBooking";

const useCancelCustomerBooking = (bookingID?: string) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState(null);

  const send = useCallback(async () => {
    if (bookingID == null) return reqState;

    setLoading();
    try {
      await cancelCustomerBooking(bookingID);
      return setSuccess(null);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [bookingID, reqState, setError, setLoading, setSuccess]);

  return { ...reqState, data: reqState.data, send };
};

export default useCancelCustomerBooking;
